<template>
  <div class="content">
    <div v-if="isWatching" class="content__videos-wrapper">
      <div class="content__video">
        <Video
          :video="video"
          :isWatching="isWatching"
          :hasWatched="hasWatched"
          :quizId="quizId"
          :hasPassedQuiz="hasPassedQuiz"
          :nextVideo="nextVideo"
          @isLoadingVideo="setLoader"
          @toggleVideo="$emit('toggleVideo')"
          @toggleWatched="$emit('toggleWatched')"
          @advanceToNextVideo="$emit('advanceToNextVideo')"
        />
      </div>
    </div>
    <div v-if="isTakingQuiz" class="content__quiz">
      <Quiz
        :quizId="quizId"
        :videoId="video.id"
        :hasPassedQuiz="hasPassedQuiz"
        :title="levelTitle"
        :nextVideo="nextVideo"
        @isLoadingQuiz="setLoader"
        @toggleQuiz="$emit('toggleQuiz')"
      />
    </div>
    <div v-if="isLoading" class="content__loader-wrapper">
      <BarLoader class="content__loader" color="#ef7d22" />
    </div>
  </div>
</template>

<script>
import { BarLoader } from '@saeris/vue-spinners'
import Video from '@/components/course/content/level/Video.vue'
import Quiz from '@/components/course/content/level/Quiz.vue'

export default {
  name: 'Content',
  components: {
    Video,
    Quiz,
    BarLoader,
  },
  props: {
    video: {
      type: Object,
      required: false,
    },
    nextVideo: {
      type: Object,
      required: false,
    },
    isWatching: {
      type: Boolean,
      required: true,
    },
    hasWatched: {
      type: Boolean,
      required: true,
    },
    quizId: {
      type: String,
      required: false,
    },
    isTakingQuiz: {
      type: Boolean,
      required: true,
    },
    hasPassedQuiz: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    levelTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    setLoader(e) {
      this.$emit('isLoading', e)
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0 0 15px 15px;
  padding: 0 15px 0 0;
  border: 1px solid var(--light-gray);
  border-top: none;
  &__loader-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0 50px 0;
  }
}
</style>
